import { SearchFaxesIO } from '../types';
import { UseFaxV1InfiniteQueryEndpointArgs, useFaxV1InfiniteQuery } from './use-fax-v1-infinite-query';

type SearchFaxesPageParams = {
  cursor?: string;
};
/**
 * A hook that returns an infinite query for the `SearchFaxes` endpoint.
 * @param request The request object to pass to the query. Overriding pagination fields on the request is handled by the hook.
 * @param options (optional) The options to pass to `useInfiniteQuery`.
 * @param httpOptions (optional) The http options to pass to the schema function.
 * @param requestKeysToOmitFromQueryKey (optional) - An array of keys to omit from the query key. This is useful for cases where the request object contains keys that cause issues
 * when included in the query key, such as the current timestamp.
 */
export const useSearchFaxesQuery = <E = unknown, D = SearchFaxesIO['output']>({
  options,
  request,
  ...args
}: UseFaxV1InfiniteQueryEndpointArgs<'SearchFaxes', E, D, SearchFaxesPageParams>) =>
  useFaxV1InfiniteQuery<'SearchFaxes', E, D, SearchFaxesPageParams>({
    endpointName: 'SearchFaxes',
    ...args,
    request: ({ pageParam }) => {
      const requestWithPageParams: SearchFaxesIO['input'] = {
        ...request,
      };
      if (pageParam?.cursor) {
        requestWithPageParams.cursor = pageParam.cursor;
      }
      return requestWithPageParams;
    },
    options: {
      ...options,
      getNextPageParam: (lastPage) => {
        return lastPage.cursor ? { cursor: lastPage.cursor } : undefined;
      },
    },
  });
